"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FeatureBannerRow;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _text = _interopRequireDefault(require("@ux/text"));
var _featureBanner = _interopRequireDefault(require("../../../feature-banner"));
var _attachmentRow = require("./attachment-row");
const BannerRowContainer = /*#__PURE__*/(0, _react2.styled)(_attachmentRow.Container)({
  name: "BannerRowContainer",
  class: "pc-b17szx4h"
});

/**
 * FeatureBannerRow Component.
 *
 * @param {Object} props React props
 * @param {String} props.rowTitle Title for each row item
 * @returns {React.ReactElement} FeatureBannerRow Component
 * @public
 */

function FeatureBannerRow({
  rowTitle,
  ...rest
}) {
  return /*#__PURE__*/_react.default.createElement(BannerRowContainer, {
    "data-cy": "feature-banner-row",
    partial: "precheck",
    className: rowTitle ? 'hasBorder' : ''
  }, rowTitle && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "title",
    text: rowTitle,
    size: 5,
    "data-cy": "row-title"
  }), /*#__PURE__*/_react.default.createElement(_featureBanner.default, rest));
}
FeatureBannerRow.propTypes = {
  rowTitle: _propTypes.default.string,
  ..._featureBanner.default.propTypes
};